import React from "react";
import AdminGenericCRUDPage from "./AdminGenericCRUDPage";

const FIELDS = [
  { name: "name",     label: "Müşteri Adı", required: true },
  { name: "logo",     label: "Logo (URL veya yükle)", type: "image" },
  { name: "website",  label: "Web Sitesi", type: "url" },
  { name: "order",    label: "Sıra", type: "number" },
];

export default function AdminClientsPage() {
  return (
    <AdminGenericCRUDPage
      title="Müşteriler"
      subtitle="Marquee'de görünen müşteri logoları"
      endpoint="/admin/clients"
      identifier="id"
      fields={FIELDS}
      defaultItem={{ name: "", logo: "", website: "", order: 0 }}
      testIdPrefix="clients"
    />
  );
}
